import React from 'react';
import { Globe } from 'lucide-react';
import { siteConfig } from '../data/mock';

const LanguageSplash = ({ onSelectLanguage }) => {
  return (
    <div className="fixed inset-0 z-[100] bg-gradient-to-b from-amber-50 via-orange-50 to-amber-100 flex items-center justify-center">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border-4 border-teal-600 rounded-full" />
        <div className="absolute bottom-20 right-10 w-24 h-24 border-4 border-amber-500 rounded-full" />
        <div className="absolute top-1/3 right-1/4 w-16 h-16 border-4 border-red-500 rounded-full" />
      </div>
      
      <div className="relative z-10 max-w-lg mx-auto px-6 text-center">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src={siteConfig.logo} 
            alt="Xicano Rights Union"
            className="w-40 md:w-56 h-auto mx-auto drop-shadow-lg"
          />
        </div>
        
        {/* Welcome Message */}
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-600/10 rounded-full text-teal-700 text-sm font-medium mb-4">
            <Globe size={16} />
            <span>Select Language / Seleccionar Idioma</span>
          </div>
          
          <h1 className="text-2xl md:text-3xl font-bold text-stone-800 mb-2">
            Welcome / Bienvenido
          </h1>
          <p className="text-stone-600">
            Choose your preferred language to continue
          </p>
          <p className="text-stone-500 text-sm">
            Elige tu idioma preferido para continuar
          </p>
        </div>
        
        {/* Language Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => onSelectLanguage('en')}
            className="group px-8 py-4 bg-white border-2 border-teal-500 hover:bg-teal-500 text-teal-700 hover:text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/25 flex items-center justify-center gap-3"
            data-testid="lang-select-en"
          >
            <span className="text-2xl">🇺🇸</span>
            <div className="text-left">
              <div className="text-lg">English</div>
              <div className="text-xs opacity-70 group-hover:opacity-90">Continue in English</div>
            </div>
          </button>
          
          <button
            onClick={() => onSelectLanguage('es')}
            className="group px-8 py-4 bg-white border-2 border-amber-500 hover:bg-amber-500 text-amber-700 hover:text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/25 flex items-center justify-center gap-3"
            data-testid="lang-select-es"
          >
            <span className="text-2xl">🇲🇽</span>
            <div className="text-left">
              <div className="text-lg">Español</div>
              <div className="text-xs opacity-70 group-hover:opacity-90">Continuar en Español</div>
            </div>
          </button>
        </div>
        
        {/* Footer Note */}
        <p className="mt-8 text-xs text-stone-400">
          You can change this anytime using the language toggle in the menu
          <br />
          Puedes cambiar esto en cualquier momento usando el selector de idioma
        </p>
      </div>
    </div>
  );
};

export default LanguageSplash;
